/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as st from './STApp'
import { componentApi, loadTranslations } from 'common'


export class STViewFilterAPI {
  async GetOptions() : Promise<st.ViewFilterOptions> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'GetOptions', {
    });
  }
  async GetChecklistPreferences() : Promise<Record<string, st.CheckListPreference>> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'GetChecklistPreferences', {
    });
  }
  async GetCollections() : Promise<Array<st.RevCollectionData>> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'GetCollections', {
    });
  }
  async UpdateCollectionGU(entityGU : string, collectionGU : string) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateCollectionGU', {
      entityGU,
      collectionGU,
    });
  }
  async SetFilter(filterGU : string, enabled : boolean) : Promise<Array<st.UserFilterObj>> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'SetFilter', {
      filterGU,
      enabled,
    });
  }
  async CreateNewFolder() : Promise<st.UserFilterGroupInfo> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'CreateNewFolder', {
    });
  }
  async DeleteGroup(filterGroupGU : string) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'DeleteGroup', {
      filterGroupGU,
    });
  }
  async UpdateGroup(group : st.UserFilterGroupInfo) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateGroup', {
      group,
    });
  }
  async UpdateCollapsedGroups(groups : Array<string>) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateCollapsedGroups', {
      groups,
    });
  }
  async UpdateGroupOrder(groups : Array<st.UserFilterGroupInfo>) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateGroupOrder', {
      groups,
    });
  }
  async UpdateFilterGroup(filterGU : string, filterGroupGU : string) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateFilterGroup', {
      filterGU,
      filterGroupGU,
    });
  }
  async UpdateFilterOrder(filters : Array<st.UserFilterObj>) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'UpdateFilterOrder', {
      filters,
    });
  }
  async DeleteFilter(filterGU : string) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'DeleteFilter', {
      filterGU,
    });
  }
  async RemoveSharedFilter(filterGU : string) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'RemoveSharedFilter', {
      filterGU,
    });
  }
  async AcceptSharedFilter(filterGU : string, filterGroupGU : string) : Promise<st.UserFilterObj> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'AcceptSharedFilter', {
      filterGU,
      filterGroupGU,
    });
  }
  async ToggleGroupExpanded(filterGroupGU : string, expanded : boolean) : Promise<any> {
    return await componentApi.call('st', 'st-view-filters', 'STViewFilterAPI', 'ToggleGroupExpanded', {
      filterGroupGU,
      expanded,
    });
  }
}
export default new STViewFilterAPI()
